module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/31b1516ffc1b43f7b6c03258c9cd977f.png";